import React from 'react';

import Accordion from '~components/Accordion';

import RoREUnallocatedList from './RoREUnallocatedList';

const RoRESideBar: React.FC = () => {
  const items = [
    {
      header: 'Unallocated Appointments',
      bodyComponent: RoREUnallocatedList,
      bodyProps: {},
    },
  ];

  return <Accordion className="side-bar-container" items={items} />;
};

export default RoRESideBar;
